import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { interval } from 'rxjs';

@Component({
  selector: 'app-hero-section',
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.scss'],
  animations: [
    trigger('divState', [
      state(
        'initial',
        style({
          opacity: '0',
          transform: 'translateY(50px)',
        })
      ),
      state(
        'show',
        style({
          opacity: '1',
          transform: 'translateY(0px)',
        })
      ),
      transition('initial => show', animate('900ms ease-in-out')),
    ]),
  ],
})
export class HeroSectionComponent implements OnInit {
  @Input() productSlogan;
  @Input() keyMessages;
  @Input() imageUrl;
  @Input() variations = [];
  show = false;
  stateName;

  activeKeyMessage;
  constructor() {}

  ngOnInit(): void {
    this.activeKeyMessage = this.keyMessages[0].keyMessage;


    
    if (this.keyMessages.length > 1) {
      this.show = !this.show;

      const test = this.ourOwnInrerval(10000);
      test.subscribe(
        (response) => {
          this.activeKeyMessage = this.keyMessages[response].keyMessage;
          console.log('test',this.activeKeyMessage);
          
          // this.stateName = this.show ? 'show' : 'initial';
          // this.show = !this.show;
        },
        (error) => {},
        () => {}
      );
    }
  }

  ourOwnInrerval(p): Observable<number> {
    let number = 0;
    return new Observable((observer) => {
      setInterval(() => {
        number = number == this.keyMessages.length ? 0 : number;

        observer.next(number++);
      }, p);
    });
  }
  changeKeyMessage(i) {
    this.activeKeyMessage = this.keyMessages[i].keyMessage;
  }
}
